import { render, staticRenderFns } from "./WorkflowCreate.vue?vue&type=template&id=70024ae8&"
import script from "./WorkflowCreate.vue?vue&type=script&lang=js&"
export * from "./WorkflowCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkflowCreate.vue"
export default component.exports